export const dictionary = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    version: { en: 'Version', ko: '버전', fr: '' },
    updateDate: { en: 'Update Date', ko: '업데이트 날짜', fr: '' },
  },
  info: {
    version: { en: 'Version', ko: '버전', fr: '' },
    updateDate: { en: 'Update date', ko: '업데이트 날짜', fr: '' },
    dictionary: { en: 'Dictionary', ko: '딕셔너리', fr: '' },
  },
  placeholder: {
    version: { en: 'Search by version', ko: '버전을 입력하세요', fr: '' },
    tag: { en: 'Search by tag', ko: '태그를 입력하세요', fr: '' },
  },
};
